<h2 mat-dialog-title>{{ 'commonShareDialog.title' | translate }}</h2>
<div class="dialog-box">
  <div>
    <div class="date-div">
      <mat-form-field class="datepicker">
        <mat-label class="top-label">{{ getPlaceholder('commonShareDialog.expirationDate' | translate) }}</mat-label>
        <input matInput id="datepicker" [min]="minDate" [max]="maxDate" [matDatepicker]="picker"
          (dateChange)="changeDateEvent($event)" [value]="sharingDateForm.value" required>
        <mat-datepicker-toggle matSuffix [for]="picker">
          <mat-icon class="datepicker-icon" matDatepickerToggleIcon>today</mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker touchUi #picker></mat-datepicker>
        <mat-error *ngIf="sharingDateForm.hasError('required')">{{ 'commonShareDialog.sharingDeadlineRequired' |
          translate }}</mat-error>
      </mat-form-field>
    </div>
    <div class="sas-div" fxLayout="row">
      <div class="sas-key-div">
        <mat-form-field fxFlex>
          <mat-label class="top-label">{{ getPlaceholder('commonShareDialog.shareURL' | translate) }}</mat-label>
          <input matInput readonly [value]="textSasKey">
        </mat-form-field>
      </div>
      <div class="copy-button-div">
        <button mat-button class="copy-button" (click)="copyToClipboard()"
          [matTooltip]="getTooltip('commonShareDialog.copySASKeyToclipboard' | translate)">
          <mat-icon class="copy-icon">content_copy</mat-icon>
        </button>
      </div>
      <div class="send-button-div">
        <a [href]="getMailTo()">
          <button mat-button class="send-button" [matTooltip]="getTooltip('commonShareDialog.sendMail' | translate)">
            <mat-icon class="mail-icon">email</mat-icon>
          </button>
        </a>
      </div>
    </div>
  </div>
  <div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
    <button mat-button color="primary" mat-dialog-close>{{ 'commonShareDialog.close' | translate }}</button>
  </div>
</div>
